import type { CustomerWizardFormDirty, CustomerWizardFormValues } from '@klear/customer-ui/customer-commit-form'
import { createEntityFormStateHelpers, type EntityFormErrorMap } from '@klear/ui/entity-form-state'

type CustomerAddressForm = CustomerWizardFormValues['address']
type CustomerTopLevelField = Extract<Exclude<keyof CustomerWizardFormValues, 'address'>, string>
type CustomerAddressField = Extract<keyof CustomerAddressForm, string>

export type CustomerFormFieldPath = CustomerTopLevelField | `address.${CustomerAddressField}`
export type CustomerFormFieldValue =
  | CustomerWizardFormValues[CustomerTopLevelField]
  | CustomerAddressForm[CustomerAddressField]

const helpers = createEntityFormStateHelpers<CustomerWizardFormValues, CustomerWizardFormDirty>()

export const markCustomerFormDirtyPaths = helpers.markDirtyPaths as (
  draft: Parameters<typeof helpers.markDirtyPaths>[0],
  paths: CustomerFormFieldPath | readonly CustomerFormFieldPath[]
) => void

export const setCustomerFormField = helpers.setField as (
  draft: Parameters<typeof helpers.setField>[0],
  path: CustomerFormFieldPath,
  value: CustomerFormFieldValue
) => void

export const clearCustomerFormErrors = helpers.clearErrors as (
  errors: EntityFormErrorMap,
  paths: CustomerFormFieldPath | readonly CustomerFormFieldPath[]
) => EntityFormErrorMap
